import React from 'react'
import { FormattedMessage } from 'react-intl';
import './SSO-CMS.css'


class SSOSuccess extends React.Component {
    componentDidMount() {
        /*setTimeout(()=>{
            window.close();
        },10000)*/
    }

    handleBtnCloudClick = (event) => {
        event.preventDefault()
        window.open('/');
    }

    handleBtnCMSEClick = (event) => {
        event.preventDefault()
        window.parent.postMessage("return-to-dashboard", "*");
    }
    render() {
        return(
            <div className='card align-items-center' >
                <div className='header text-center'>
                    <h2><FormattedMessage id="CMSE_CONNECT_SUCCESS" /></h2>                    
                </div>
                <div className='mt-2'>
                    <button type='button' className='btn btn-primary btn-block' onClick={this.handleBtnCloudClick}>
                        <FormattedMessage id="SCREENBEAM_CLOUD" />
                        <img className="cloud-link-icon" src="/images/cloud-link-white.svg"/>
                    </button>
                </div>
                <div className='mt-2 red'>
                    <label className='form-label label_hover red' onClick={this.handleBtnCMSEClick}><FormattedMessage id="RETURN_TO_CMSE_DASHBOARD" /></label>
                </div>
            </div>
        )
    }
}

export default SSOSuccess;